import debounce from 'lodash/debounce.js';

export default {
    install(app) {
        const saveNote = async (note, previousNote) => {
            try {
                if (!note || (!note.id && !note.title && !note.body)) {
                    return;
                }

                const hasChanges = JSON.stringify(note) !== JSON.stringify(previousNote);

                if (!hasChanges) {
                    return;
                }

                if (note.id) {
                    await app.$store.dispatch('NoteDrawer/updateNote', {
                        id: note.id,
                        data: {
                            title: note.title,
                            body: note.body,
                            course_id: note.course_id,
                            activity_id: note.activity_id,
                            media: note.media,
                            tags: note.tags,
                        },
                    });
                } else {
                    await app.$store.dispatch('NoteDrawer/createNote', {
                        title: note.title,
                        body: note.body,
                        course_id: note.course_id,
                        activity_id: note.activity_id,
                        media: note.media,
                        tags: note.tags,
                    });
                }
            } catch (error) {
                app.$store.dispatch('NoteDrawer/setError', {
                    message: 'Error auto-saving note',
                    error,
                });
            }
        };

        const debouncedSave = debounce(saveNote, 1000);
        let previousNote = null;
        let isInitialLoad = true;

        app.$store.subscribe((mutation, state) => {
            if (mutation.type === 'NoteDrawer/AUTO_SAVE') {
                const note = state.NoteDrawer;

                if (isInitialLoad) {
                    previousNote = JSON.parse(JSON.stringify(note));
                    isInitialLoad = false;
                    return;
                }

                if (!note || (!note.id && !note.title && !note.body)) {
                    return;
                }

                const hasChanges = JSON.stringify(note) !== JSON.stringify(previousNote);

                if (hasChanges) {
                    debouncedSave(note, previousNote);
                    previousNote = JSON.parse(JSON.stringify(note));
                }
            }
        });
    },
};
